import { render, staticRenderFns } from "./OverlayCanvasComponent.vue?vue&type=template&id=7b1e3546&"
import script from "./OverlayCanvasComponent.vue?vue&type=script&lang=ts&"
export * from "./OverlayCanvasComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports